import { useAppState, TypedUseAppState } from '@core-ui/app-state-provider';
import { PageState } from '../../../types/app';

export const useClpState = useAppState as TypedUseAppState<PageState>;
